// extracted by mini-css-extract-plugin
module.exports = {"orderListSectionList":"OrderListSectionList-Jtails_orderListSectionList_3UC16","orderList":"OrderListSectionList-Jtails_orderList_hwLsd"};